<template>
  <v-card class="card-base login-card">
    <img src="@/assets/img/eis.png" class="eis-logo-grey" alt="" />
    <div class="d-flex flex-column w-100">
      <div>
        <div class="text-big-size login-card__title">Добро пожаловать</div>
        <div class="text-small-size login-card__text">
          Вы находитесь в Личном кабинете заявителя на портале Федеральной
          нотариальной палаты
          <br />
          Авторизуйтесь, чтобы воспользоваться услугами и сервисами портала.
        </div>
      </div>

      <div class="d-flex align-center mt-auto pt-8">
        <v-btn
          @click.prevent="onLogin"
          depressed
          color="primary"
          class="button-base login-card__button"
          >Войти</v-btn
        >
        <div class="login-in-gs">
          <div class="text-small-size text">Вход через портал</div>
          <img src="@/assets/img/gos-uslugi.svg" alt="" />
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { AuthModule } from '@/store/modules/auth';

export default {
  name: 'LoginCard',
  methods: {
    async onLogin() {
      await AuthModule.login();
    },
  },
};
</script>

<style scoped lang="scss">
.w-100 {
  width: 100%;
}

.login-card {
  display: flex;
  height: 260px;
  padding-left: 82px;
  padding-top: 42px;
  padding-bottom: 32px;
  position: relative;
  color: $color-base;
  overflow: hidden;
  height: 100%;

  @media screen and (max-width: $gr-sm) {
    padding-left: 15px;
    padding-right: 15px;

    & .v-btn {
      min-width: 154px !important;
    }
  }

  &__title {
    color: $color-base;
    margin-bottom: 12px;
  }

  &__text {
    color: $color-base;
  }

  & .eis-logo-grey {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);

    position: absolute;
    height: 100%;
    right: 28px;
    top: 0;
    opacity: 0.1;
    transform: scale(1.5);
  }
}

.login-in-gs {
  color: $color-base;
  display: flex;
  align-items: baseline;
  flex-direction: column;
  margin-left: 15px;
}
</style>
